<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  <h3>Paramètres de l'investissement</h3>

  <pr-input label="Valeur du bien" suffix="€" [derrors]="derrors">
    <input formControlName="investedAmount" type="text" />
  </pr-input>

  <pr-input label="Durée du projet" suffix="ans" [derrors]="derrors">
    <input
      formControlName="duration"
      type="text"
      (change)="onProjectDurationChange()"
    />
  </pr-input>

  <pr-input label="Rendement locatif" suffix="%" [derrors]="derrors">
    <input formControlName="rentalReport" type="text" />
  </pr-input>

  <pr-input label="Revalorisation foncière" suffix="%" [derrors]="derrors">
    <input formControlName="propertyRevaluation" type="text" />
  </pr-input>

  <pr-input label="Revalorisation locative" suffix="%" [derrors]="derrors">
    <input formControlName="rentalReversion" type="text" />
  </pr-input>

  <!-- Charge -->
  <h3>Paramètres des charges</h3>

  <pr-input label="Frais de notaire" suffix="%" [derrors]="derrors">
    <input formControlName="notaryFees" type="text" />
  </pr-input>

  <pr-input label="Taxe foncière" suffix="%" [derrors]="derrors">
    <input formControlName="estateTax" type="text" />
    <span subLabel class="fs-12 text-secondary"
      >En pourcentage du loyer mensuel</span
    >
  </pr-input>

  <pr-input label="Frais de gestion" suffix="%" [derrors]="derrors">
    <input formControlName="managementFeesPercentage" type="text" />
  </pr-input>

  <pr-input label="Frais de copropriété" suffix="%" [derrors]="derrors">
    <input formControlName="coOwnershipFeesPercentage" type="text" />
  </pr-input>

  <!-- Credit -->
  <h3>Paramètres du crédit</h3>

  <pr-input-radio
    formControlName="cashOrCredit"
    label="Investissement"
    [options]="[
      { value: 'CASH', label: 'Cash' },
      { value: 'CREDIT', label: 'Credit' },
    ]"
  >
  </pr-input-radio>

  <pr-input
    [hidden]="inCash"
    label="Durée du credit"
    suffix="mois"
    [derrors]="derrors"
  >
    <input
      formControlName="loanDuration"
      type="text"
      (change)="onProjectDurationChange()"
    />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Taux du crédit"
    suffix="%"
    [derrors]="derrors"
  >
    <input formControlName="loanRate" type="text" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Frais de dossier"
    suffix="€"
    [derrors]="derrors"
  >
    <input formControlName="bankingFees" type="text" />
  </pr-input>
</pr-form>
